import { render } from "./TimeControlCategory.vue?vue&type=template&id=1ddebe30&scoped=true"
import script from "./TimeControlCategory.vue?vue&type=script&lang=js"
export * from "./TimeControlCategory.vue?vue&type=script&lang=js"

import "./TimeControlCategory.vue?vue&type=style&index=0&id=1ddebe30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddebe30"]])

export default __exports__